const build = `{
  "require": {
      "stripe/stripe-php": "^6.31"
  }
}
`;

export default {
  build,
};
